import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-learn",
  "use": "icon-leo-learn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-learn\">\r\n<g transform=\"translate(-176.128 -133.120) scale(1.344000)\">\r\n<path d=\"M192 288l320-128 320 128v320L512 800 192 608V288zm96 80v208l224 128 224-128V368L512 256 288 368z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-learn.svg
// module id = wl0X
// module chunks = 492